var x = "/static/fdf25a1963f11714.png";

export { x as default };
//# sourceMappingURL=level_up_vip.png.js.map
